import { useState } from 'react';
import { useForm } from 'react-hook-form';
import useSaveSouscriptionCompanyMutation from './useSaveSouscriptionCompanyMutation';
import { propOr } from 'ramda';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { ensurePhonesArray } from '@@viewHelpers/ensurePhonesArray.js';

const useSouscriptionCompanyForm = ({ getSouscriptionCompany }) => {
  const [loading, setLoading] = useState(false);
  const { processHandlers, context } = useProcess();

  const saveSouscriptionCompany = useSaveSouscriptionCompanyMutation();

  const $onClickPrev = () => {
    processHandlers.onPrev({
      context: {
        projectId: context?.projectId
      }
    });
  };

  const onSubmit = (values) => {
    if (loading) return;
    setLoading(true);

    saveSouscriptionCompany.onFormSubmit(values, (ok, error) => {
      if (ok && !error) {
        processHandlers.onNext({
          context: {
            projectId: context?.projectId
          }
        });
      } else {
        setLoading(false);
      }
    });
  };

  const form = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      decisionMakerContact: ensurePhonesArray(
        propOr({}, 'decisionMakerContact', getSouscriptionCompany)
      ),
      hrContact: ensurePhonesArray(
        propOr({}, 'hrContact', getSouscriptionCompany)
      )
    }
  });

  return {
    $onClickPrev,
    form,
    onSubmit
  };
};

export default useSouscriptionCompanyForm;
